import { useLazyQuery } from '@netfront/apollo-providers';

import { GET_TAMARIN_PROJECT_QUERY } from './useGetTamarinProject.graphql';
import {
  IGetTamarinProjectQueryGraphQLResponse,
  IHandleGetTamarinProjectParams,
  IUseGetTamarinProject,
  IUseGetTamarinProjectOptions,
} from './useGetTamarinProject.interfaces';

const useGetTamarinProject = (options?: IUseGetTamarinProjectOptions): IUseGetTamarinProject => {
  const { fetchPolicy, onCompleted, onError } = options ?? ({} as IUseGetTamarinProjectOptions);

  const { handleQuery: executeGetTamarinProject, isLoading = false } = useLazyQuery({
    apiName: 'tamarin',
    fetchPolicy: fetchPolicy ?? 'cache-and-network',
    // apollo-providers still calls onCompleted, with undefined data, when the request fails (e.g. a network error) and onError reports it
    onCompleted: (data?: IGetTamarinProjectQueryGraphQLResponse) => {
      const project = data?.project.getTamarinProject;

      if (!onCompleted || !project) {
        return;
      }

      onCompleted({
        project,
      });
    },
    onError,
    query: GET_TAMARIN_PROJECT_QUERY,
  });

  // Also returns the project, so a caller can tell which request it belongs to: onCompleted runs for every response
  const handleGetTamarinProject = async ({ id }: IHandleGetTamarinProjectParams) => {
    // apollo-providers resolves to undefined when the request fails
    const data = (await executeGetTamarinProject({
      id,
    })) as IGetTamarinProjectQueryGraphQLResponse | undefined;

    return data?.project.getTamarinProject;
  };

  return {
    handleGetTamarinProject,
    isLoading,
  };
};

export { useGetTamarinProject };
